:host{display:block;max-height:75vh}
/*# sourceMappingURL=cv-feedback-panel.component.css.map */
